import { useState } from "react";
import { useFilters } from "../../../../Components/Filters/Filters.hook";
import { useDebouncedCallback } from "../../../../GlobalHooks/useDebounce";
import { Polygon, SimplifyPolygon } from "../../../../Utils/Polygons";

export const DEFAULTS_CENTERS = {
	UY: {
		lat: -34.9030204,
		lng: -56.1494,
	},
	BR: {
		lat: -23.533773,
		lng: -46.62529,
	},
	BO: {
		lat: -17.78384441916698,
		lng: -63.18170783634185,
	},
	PY: {
		lat: -25.2966809,
		lng: -57.6681289,
	},
	PE: {
		lat: -12.081724,
		lng: -77.054388,
	},
	CE3: {
		//Casas en el este, coordenadas punta del este
		lat: -34.9456,
		lng: -54.9358,
	},
	CO: {
		lat: 4.7117,
		lng: -74.0721,
	},
};

const useSearchResultsMapWithBackend = () => {
	const { filters, changeFilters } = useFilters();
	const [selectedMarker, setSelectedMarker] = useState(0);

	const removeLocation = () => {
		changeFilters({ estate_id: null, neighborhood_id: [] });
	};

	const mapRegionChanged = (bounds: Polygon, zoomLevel: Number) => {
		changeFilters({ map_polygon: { text: "Búsqueda por área", value: bounds }, mapView: true });
	};

	const setPolygon = polygon => {
		if (polygon != null && polygon.length > 2) {
			const p = SimplifyPolygon(polygon, 0.0004, false);
			changeFilters({
				map_polygon: { text: "Dibujo en el Mapa", value: [...p, p[0]] },
			});
		} else {
			changeFilters({ map_polygon: null });
		}
	};

	const selectMarker = propertyId => {
		setSelectedMarker(propertyId);
	};

	return {
		mapRegionChanged,
		removeLocation,
		polygon: filters && filters.map_polygon ? filters.map_polygon : [],
		setPolygon,
		selectedMarker,
		selectMarker
	};
};

export { useSearchResultsMapWithBackend };